import React from "react";

const PlaceHolderRoom = () => (
    <div
        role="status"
        className="p-4 space-y-8 border-2 md:mx-[250px] xl:h-full xl:mx-0 mx-4 xl:w-full md:h-[400px] rounded-xl animate-pulse xl:space-y-0 xl:space-x-8 rtl:space-x-reverse flex flex-col xl:flex-row xl:items-center"
    >
        <div className="flex items-center justify-center w-full xl:w-20 xl:h-16 md:h-[500px] h-[250px] bg-gray-300 rounded dark:bg-gray-700">
            <svg
                className="w-8 h-8 text-gray-200 dark:text-gray-600"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 18"
            >
                <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
            </svg>
        </div>
        <div className="flex-1">
            <div className="h-2 bg-gray-200 mt-3 rounded-full dark:bg-gray-700 max-w-[80%] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[75%] mb-2.5"></div>
        </div>
        <div className="flex-1 block xl:hidden">
            <div className="h-2 bg-gray-200 mt-3 rounded-full dark:bg-gray-700 max-w-[80%] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[75%] mb-2.5"></div>
        </div>
        <span className="sr-only">Loading...</span>
    </div>
);

export default PlaceHolderRoom;
